const FolderTypeConstant = {
  REPAIR_FOLDER: 'REPAIR_FOLDER',
  PROSPECT_FOLDER: 'PROSPECT_FOLDER'
}

export default FolderTypeConstant;
